import { __makeTemplateObject } from "tslib";
import MuiButtonBase from '@material-ui/core/ButtonBase';
import { styled } from '../../../foundation';
/** @release */
var RcButtonBase = styled(MuiButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcButtonBase.displayName = 'RcButtonBase';
export { RcButtonBase };
var templateObject_1;
